export default "__VITE_ASSET__Bsj9Kq9B__"